export default __webpack_public_path__ + "static/media/fanda.500ec10f.jpg";